import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomCalendar from "./Components/Calendar";
import AttendanceTable from "./Components/AttendanceTable";
import Statistics from "./Components/Stats";
import Header from "./Components/Header";
import { Tabs, Button } from "antd";
import LeaveRequests from "./Components/LeaveRequests";
import { useTranslation } from "react-i18next";
import { fetchAttendanceByDate, markStaffAttendance } from "../../../../Store/Slices/Admin/staffAttendance/staffAttendance.thunk";
import { setSelectedDate } from "../../../../Store/Slices/Admin/staffAttendance/staffAttendance.slice";
import ProtectedSection from "../../../../Routes/ProtectedRoutes/ProtectedSection";
import { PERMISSIONS } from "../../../../config/permission";
import AcademicPeriodPicker from "../../../../Components/Common/AcademicPeriodPicker";
import { markAllStaffAttendance } from "../../../../Store/Slices/Admin/staffAttendance/staffAttendance.slice";

const MainSection = () => {
  const { t } = useTranslation("admClass");
  const dispatch = useDispatch();
  const { attendanceData, selectedDate, markingAttendance } = useSelector(
    (state) => state.admin.staffAttendance
  );

  // Normal submit for already selected statuses
  const handleMarkAttendance = () => {
    const attendanceToMark = attendanceData
      ?.filter(staff => ["present", "absent", "leave"].includes(staff.attendanceStatus))
      .map(staff => ({
        staffId: staff.StaffId,
        status: staff.attendanceStatus,
      }));

    if (attendanceToMark.length === 0) return;

    dispatch(
      markStaffAttendance({
        date: selectedDate,
        staffEntry: attendanceToMark,
      })
    );
  };

  // NEW: Mark everyone at once with the selected status
  const handleMarkAll = (status) => {
    if (!status || attendanceData?.length === 0) return;
    dispatch(markAllStaffAttendance({status}))
  };

  useEffect(() => {
    dispatch(fetchAttendanceByDate({
      date: selectedDate,
      startDate: selectedDate,
      endDate: selectedDate,
    }));
  }, [dispatch, selectedDate]);

  return (
    <div className="flex min-h-screen w-full">
      <div className="w-8/12 p-4 bg-white border-e flex flex-col">
        {/* Button group for marking all staff */}


        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab={t("Attendance")} key="1" className="mx-3">
            <div className="mb-2 flex justify-end space-x-2 ">
              <Button onClick={() => handleMarkAll("present")} type="primary" className="mx-2">
                {t("Mark All Present")}
              </Button>
              <Button onClick={() => handleMarkAll("absent")} danger >
                {t("Mark All Absent")}
              </Button>
              <Button onClick={() => handleMarkAll("leave")} className="bg-yellow-400 text-black hover:bg-yellow-300 mx-2">
                {t("Mark All Leave")}
              </Button>
            </div>
            <AttendanceTable staffs={attendanceData} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t("Leave Requests")} key="2">
            <ProtectedSection requiredPermission={PERMISSIONS.VIEW_LEAVE_REQUESTS}>
              <LeaveRequests />
            </ProtectedSection>
          </Tabs.TabPane>
        </Tabs>
      </div>

      <div className="w-4/12 p-4 bg-white flex flex-col space-y-4">
        <Header onSubmit={handleMarkAttendance} />
        <div className="flex justify-center">
          <AcademicPeriodPicker
            mode="day"
            onChange={(date) => {
              // date will be "YYYY-MM-DD"
              dispatch(setSelectedDate(date));
            }}
          />

        </div>
        <div className="flex-grow overflow-auto p-3 w-full">
          <Statistics staffs={attendanceData} />
        </div>
      </div>
    </div>
  );
};

export default MainSection;
